export var EBackgroundFit = /* @__PURE__ */ ((EBackgroundFit2) => {
  EBackgroundFit2["FILL"] = "fill";
  EBackgroundFit2["FIT_WIDTH"] = "fit-width";
  return EBackgroundFit2;
})(EBackgroundFit || {});
